// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator'
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';



const ActionsOrganizerCoops = (props: Actions & Props) => {
  const {
    CopyAction,
    RefreshAction,
    MultiSortAction,
    clearInternalFilters,
    loading,
    displayRowMenu,
  } = props;

  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            <CopyAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
          </ActionsColumn>

          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        {displayRowMenu &&
          <div className='action-menu-items'>
            <ActionsColumn>
              <table>
                <tbody>
                  <tr>
                    <td><CopyAction /></td>
                  </tr>
                </tbody>
              </table>
            </ActionsColumn>
          </div>
        }
      </MobileView>
    </>
  );
};



export default ActionsOrganizerCoops;
